import React, { PropsWithChildren } from 'react'

import * as S from './styles'
import { Image, Text } from '@/components'
import { ServiceDetailCard } from '@/components/serviceDetailCard'
import { ServiceDetailsProps } from '@/service/api/servicesPage'

export type ServiceDetailContainerProps = PropsWithChildren<{
  data: ServiceDetailsProps
}>

export const ServiceDetailContainer: React.FC<ServiceDetailContainerProps> = ({
  data,
}) => (
  <S.Container>
    {data.details.length > 0 &&
      data.details.map((item) => (
        <ServiceDetailCard
          key={item.firstTitle}
          firstTitle={item.firstTitle}
          firstDescription={item.firstDescription}
          firstSubtitle={item.firstSubtitle}
          secondTitle={item.secondTitle}
          secondDescription={item.secondDescription}
          secondSubtitle={item.secondSubtitle}
          image={item.image}
          invert={item.invert}
        />
      ))}
    <div className="logo">
      <Image
        src={data.logo.url || ''}
        alt={data.logo.alternativeText}
        fileName={data.logo.name}
        defaultSize={{
          height: data.logo.height || 0,
          width: data.logo.width || 0,
        }}
      />
      <Text size="h4" className="title-logo">
        {data.titleLogo}
      </Text>
    </div>
  </S.Container>
)
